import { gql } from "@apollo/client";
import SearchableQuerySelector from "./SearchableQuerySelector";

export const FETCH_PRODUCTS_FOR_ODOO_STYLE_SELECTOR = gql`
  query FETCH_PRODUCTS_FOR_ODOO_STYLE_SELECTOR(
    $q: String
    $offset: Int
    $limit: Int
    $isSalable: Boolean
    $isActiveOnly: Boolean
    $company: String
    $priceListId: ID
    $preferPriceListId: ID
    $preferStockCategoryId: ID
  ) {
    products(
      hasOdooId: true
      productType: "normal"
      q: $q
      offset: $offset
      limit: $limit
      isSalable: $isSalable
      isActiveOnly: $isActiveOnly
      company: $company
      priceListId: $priceListId
      preferPriceListId: $preferPriceListId
      preferStockCategoryId: $preferStockCategoryId
    ) {
      total
      results {
        id
        isActive
        odooId
        odooIdInc
        number
        name
        version
        countryCodeOfOrigin
        itemsPerSet
        inPreferredPriceList
      }
    }
  }
`;

const OdooStyleProductSelector = ({
  company,
  onSelect,
  onBlur,
  valueView,
  optionView,
  placeholder = "Search by product number or name",
  className = "",
  disabled = false,
  limit = 100,
  isSalable = true,
  isActiveOnly = true,
  fetchPolicy = "network-only",
  autoFocus = false,
  priceListId,
  preferPriceListId,
  preferStockCategoryId,
}) => {
  const renderProductOption =
    optionView ||
    ((product) => (
      <div>
        <div className="font-semibold">
          {product.number} ({product.countryCodeOfOrigin})
        </div>
        <div>{product.name}</div>
        {preferPriceListId && !product.inPreferredPriceList && (
          <div className="text-red-600 dark:text-red-700 font-semibold">
            Not in the price list for this order.
          </div>
        )}
      </div>
    ));

  return (
    <SearchableQuerySelector
      query={FETCH_PRODUCTS_FOR_ODOO_STYLE_SELECTOR}
      queryVariables={{
        limit,
        offset: 0,
        isSalable,
        isActiveOnly,
        company,
        priceListId,
        preferPriceListId,
        preferStockCategoryId,
      }}
      buildQueryVariables={({ searchText, queryVariables }) => ({
        ...queryVariables,
        q: searchText || undefined,
      })}
      resolveOptions={(data) => data?.products?.results || []}
      optionView={renderProductOption}
      optionKey="id"
      loadingText="Searching products..."
      emptyText="No products found"
      onSelect={onSelect}
      onBlur={onBlur}
      valueView={valueView}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      fetchPolicy={fetchPolicy}
      autoFocus={autoFocus}
    />
  );
};

export default OdooStyleProductSelector;
